import React from "react";
import styles from "./LangSelector.module.css";

const ThemeSelector = ({ searchParams, selectedTheme, selectedThemeMode }) => {
    return (
        <div>
            <div className={styles.flexCenter}>
                <select className={styles.select} value={selectedThemeMode} onChange={(e) => {
                    if (e.target.value) {
                        searchParams.set("themeMode", e.target.value);
                    } else {
                        searchParams.delete("themeMode");
                    }
                    window.location.search = searchParams.toString();
                }}>
                    <option value="">Mode: default</option>
                    <option value="light">Mode: light</option>
                    <option value="dark">Mode: dark</option>
                </select>
            </div>
            <div className={styles.flexCenter}>
                <select className={styles.select} value={selectedTheme} onChange={(e) => {
                    searchParams.set("theme", e.target.value);
                    window.location.search = searchParams.toString();
                }}>
                    <option value="kung" >Kung</option>
                    <option value="dbet">Dbet</option>
                    <option value="orange">Orange</option>
                    <option value="orange_light">Orange Light</option>
                    <option value="wood">Wood</option>
                    <option value="lion">Lion</option>
                    <option value="video">Video</option>
                    <option value="mrvegas">MrVegas</option>
                    <option value="green">Green</option>
                    <option value="comeon">ComeOn</option>
                    <option value="hajper">Hajper</option>
                    <option value="snabbare">Snabbare</option>
                    <option value="mega">Mega</option>
                    <option value="lyllo">Lyllo</option>
                    <option value="stugan">Stugan</option>
                    <option value="kryss">Kryss</option>
                    <option value="hard">Hard</option>
                    <option value="gogo">Gogo</option>
                    <option value="reviant">Reviant</option>
                </select>
            </div>
        </div>
    );
}

export default ThemeSelector;